import React, { forwardRef } from "react"
import cx from "classnames"

import { kebabCase } from "lodash"

const SourceTab = forwardRef(({ title, icon, active, onClick }, ref) => {
  const className = cx(
    "flex items-center px-3 py-2 w-full text-left focus:outline-blue border border-transparent rounded hover:bg-gray-50",
    {
      "bg-gray-50": active
    }
  )

  return (
    <button
      ref={ref}
      aria-expanded={active}
      className={className}
      onClick={onClick}
      data-testid={`${kebabCase(title)}-tab-picker`}
    >
      <div className="flex justify-center items-center w-8 h-8 mr-3 flex-shrink-0">
        {icon}
      </div>
      <span className="text-sm text-gray-800 font-semibold truncate">
        {title}
      </span>
    </button>
  )
})

export default SourceTab
